import React, {useEffect} from "react";
import {useDispatch} from "react-redux";
import PropTypes from "prop-types";
import PlacesList from "../../components/PlacesList";
import {getManagedEvents} from "../../actions/me";
import "./main.scss"
const ManageEvents = (props) => {
    const dispatch = useDispatch();
    const getEvents = async (params) => {
        const {events} = await dispatch(getManagedEvents(params));
        return events;
    };
    return (
        <div className="manage-events">
            <PlacesList
                title = "Manage events"
                getPlaces={getEvents}
                to={"/event/%s/edit"}
            />
        </div>
    );
};

ManageEvents.propTypes = {

};

export default ManageEvents;
